import React, { Component, Fragment } from "react";
import { METRICAS } from "../../../../constants/metricas";

export default class MetricaSelect extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <form>
                    <div className="form-group">
                        <label>Métrica: </label>
                        <select name="selectMetrica" onChange={this.props.selectMetrica} className="form-control" value={this.props.campo} id={this.props.idComponente || "selectMetrica"}>
                            {METRICAS.map((m) => <option key={m.campo} value={m.campo}>{m.label}</option>)}
                        </select>
                    </div>
                </form>
            </Fragment>
        )
    }
}
